module.exports = __webpack_public_path__ + "static/img/company_history1958.66128ed6.jpg";